/**
 * Route for `ios-14-server-side-consented-attribution-path`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { Ios14ServerSideConsentedAttributionPathPage } from "../features/ios-14-server-side-consented-attribution-path/Ios14ServerSideConsentedAttributionPathPage";

export const ios14ServerSideConsentedAttributionPathRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/ios-14-server-side-consented-attribution-path",
	component: Ios14ServerSideConsentedAttributionPathPage,
});

export default ios14ServerSideConsentedAttributionPathRoute;
